import React, { Component } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';

class RenameModal extends Component {
    state = {
        isChanged: false,
        newName: '',
        key: 0,
    };

    close = () => {
        this.setState({
            isChanged: false,
            newName: '',
            key: (this.state.key + 1) % 2,
        });
        this.props.closeCallback();
    }

    save = () => {
        if (!this.state.isChanged) {
            this.close();
        } else {
            this.props.rename(this.props.uuid, this.state.newName).then(
                () => {
                    this.props.refreshCallback();
                    this.close();
                },
                () => {
                    message.error(`Failed to rename ${this.props.type}`);
                });
        }
    };

    onKeyDown(event) {
        var key = event.key;
        if (key === 'Enter') {
            this.save();
        }
        if (key === 'Escape') {
            this.close();
        }
    }

    onChange(event) {
        this.setState({
            newName: event.target.value,
            isChanged: true
        });
    }

    render() {
        return(
            <Modal 
                className="rename-modal"
                open={this.props.isOpen}
                title={"Rename: " + this.props.name}
                onOk={this.save}
                onCancel={this.close}
                closable={true}
                footer={[
                    <Button key="save" type="primary" onClick={this.save}>Save</Button>,
                    <Button key="back" onClick={this.close}>Cancel</Button>
                ]}>
                <Form>
                    <Form.Item>
                        <Input
                            key={this.props.name + this.state.key} // change the key to cause an update
                            defaultValue={this.props.name}
                            onKeyDown={(e) => this.onKeyDown(e)}
                            onChange={(e) => this.onChange(e)}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default RenameModal;